module.exports = "/assets/wrf04-temperature-sensor-configuration-right.png";